
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useThematicTrails = () => {
  return useQuery({
    queryKey: ['thematic_trails'],
    queryFn: async () => {
      const { data, error } = await supabase.from('thematic_trails').select('*').order('created_at', { ascending: false });
      if (error) throw error;
      return data;
    },
  });
};

export const useCreateThematicTrail = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (trail: { title: string; description: string; status?: string }) => {
      const { data, error } = await supabase
        .from('thematic_trails')
        .insert(trail)
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['thematic_trails'] });
    },
  });
};

export const useThematicTrailItems = (trailId: string) => {
  return useQuery({
    queryKey: ['thematic_trail_items', trailId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('thematic_trail_items')
        .select('*')
        .eq('trail_id', trailId)
        .order('order_index', { ascending: true });
      if (error) throw error;
      return data;
    },
    enabled: !!trailId,
  });
};
